// src/components/Breadcrumb.js
import React from "react";
import { useMatches, Link } from "react-router-dom";
import './Breadcrumb.css'
const Breadcrumb = () => {
  const matches = useMatches();

  // Filter out routes that don't have a breadcrumb in the handle
  const breadcrumbs = matches
    .filter((match) => match.handle?.breadcrumb)
    .map((match) => ({
      label: match.handle.breadcrumb,
      href: match.pathname,
    }));

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {breadcrumbs.map((crumb, index) => (
          <li key={index} className="breadcrumb-item">
            {index < breadcrumbs.length - 1 ? (
              <>
                <Link to={crumb.href}>{crumb.label}</Link>
                <span className="separator"> &gt; </span>
              </>
            ) : (
              <span>{crumb.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
